<template>

    <div
        class="posts-js-container"
        :class="{ 'fl-post-columns': columnLayout, 'fl-post-feed': feedLayout }"
        >

        <Post v-bind:key="postObj.id" v-for="postObj in sortedPosts"
            :postObj="postObj"
            :moduleSettings="moduleSettings"
            :columnLayout="columnLayout"
            :feedLayout="feedLayout"
        />

    </div>

</template>

<script>

import moment from 'moment'
import Post from './Post.vue'

export default {
  props: {
    posts: {
      type: Object
    },
    moduleSettings: {
      type: Object
    }
  },
  components: {
    Post
  },
  computed: {
    sortedPosts: function () {
      let results = []
      const moduleSettings = this.moduleSettings
      const posts = this.posts

      // Sorting helper: Descending
      const compareByOrderbyDesc = (a, b) => {
        let postA = a.title
        let postB = b.title

        if (this.moduleSettings.orderby === 'date') {
          postA = moment(a.date, 'D.M.YYYY')
          postB = moment(b.date, 'D.M.YYYY')
        }

        if (this.moduleSettings.orderby === 'id') {
          postA = parseInt(a.id)
          postB = parseInt(b.id)
        }

        if (postA < postB) { return 1 } else if (postA > postB) { return -1 } else { return 0 }
      }

      // Sorting helper: Ascending
      const compareByOrderbyAsc = (a, b) => {
        let postA = a.title
        let postB = b.title

        if (this.moduleSettings.orderby === 'date') {
          postA = moment(a.date, 'D.M.YYYY')
          postB = moment(b.date, 'D.M.YYYY')
        }

        if (this.moduleSettings.orderby === 'id') {
          postA = parseInt(a.id)
          postB = parseInt(b.id)
        }

        if (postA > postB) { return -1 } else if (postA < postB) { return 1 } else { return 0 }
      }

      function sourceIndexToPosts (batch, index) {
        const res = batch.map((post) => {
          return Object.assign({}, post, { source: index })
        })

        return res
      }

      for (let sourceIndex in posts) {
        // Add source index to posts
        results = results.concat(sourceIndexToPosts(posts[sourceIndex], sourceIndex))
      };

      // Order posts
      if (moduleSettings['order'] === 'ASC') {
        results = results.sort(compareByOrderbyAsc)
      } else {
        results = results.sort(compareByOrderbyDesc)
      }

      return results
    },
    columnLayout: function () {
      const moduleSettings = this.moduleSettings
      return moduleSettings.layout === 'columns'
    },
    feedLayout: function () {
      const moduleSettings = this.moduleSettings
      return moduleSettings.layout === 'feed'
    }
  }
}
</script>
